import { render, staticRenderFns } from "./RelationToListInfo.vue?vue&type=template&id=5610ae0e&scoped=true&"
import script from "./RelationToListInfo.vue?vue&type=script&lang=ts&"
export * from "./RelationToListInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5610ae0e",
  null
  
)

export default component.exports